import {
    useMemo,
} from 'react'

import {
    DetailPanelComponentProps,
} from 'app/shared-components/SkyNetDataGridExpandable'
import longTermLeaseInvoiceRequests from 'app/requests/LongTermLeaseInvoice/LongTermLeaseInvoice.requests'

import useLongTermLeaseInvoicePositionContext from '../hooks/useLongTermLeaseInvoicePositionContext'
import LongTermLeaseInvoicePositionForm from '../LongTermLeaseInvoicePositionForm'

const LongTermLeaseInvoicePositionCreate = ({
    onSuccess,
    onCancel,
}: Readonly<DetailPanelComponentProps>) => {
    const {
        longTermLeaseInvoiceId,
    } = useLongTermLeaseInvoicePositionContext()

    const requestParams = useMemo(() => {
        return longTermLeaseInvoiceRequests.createPosition({
            longTermLeaseInvoiceId,
        })
    }, [longTermLeaseInvoiceId])

    return (
        <LongTermLeaseInvoicePositionForm
            onSuccess={onSuccess}
            onCancel={onCancel}
            requestParams={requestParams}
        />
    )
}

export default LongTermLeaseInvoicePositionCreate
